import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import { ManifestNavigationTreeLoadingSkeleton } from "~/areas/tasks/components/Task/Kubernetes/Manifests/ManifestNavigationTreeLoadingSkeleton";
import { ManifestViewerListLoadingSkeleton } from "~/areas/tasks/components/Task/Kubernetes/Manifests/ManifestViewerListLoadingSkeleton";
const styles = {
    container: css({
        display: "flex",
        flexDirection: "row",
    }),
    navigationContainer: css({
        width: `calc(${space[16]} * 25)`, // 400px
        paddingLeft: space[16],
        paddingRight: space[16],
    }),
    manifestsContainer: css({
        flexGrow: 1,
        paddingRight: space[16],
    }),
};
export const KubernetesAppliedManifestsLoadingSkeleton = () => (<div className={styles.container}>
        <div className={styles.navigationContainer}>
            <ManifestNavigationTreeLoadingSkeleton />
        </div>
        <div className={styles.manifestsContainer}>
            <ManifestViewerListLoadingSkeleton />
        </div>
    </div>);
